import React from "react"
import Back from "../common/back/Back"
import CoursesCard from "./CoursesCard"
import OnlineCourses from "./OnlineCourses"
import Programmes from "./Programmes"
import Faculties from "./Faculties"

const CourseHome = () => {
  return (
    <>
      <Back title='Explore Courses' />
     
  <Faculties />
    </>
  )
}

export default CourseHome
